<template>
    <div>
        <button @click="goHome">Go Home</button>
        
    </div>
</template>

<script>
export default {
    name:"notfound",
    methods:{
        goHome(){
            this.$router.push({name:'home'})
        }
    }
}
</script>